import { fbt } from 'fbtee'
import { Button } from '../../components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog'

/** Asks a freshly signed-in guest to become a full member of the group they previewed. */
export function JoinGroupDialog({
  open,
  groupName,
  onDismiss,
  onJoin,
}: {
  open: boolean
  groupName: string
  onDismiss: () => void
  onJoin: () => void
}) {
  return (
    <Dialog open={open} onOpenChange={o => !o && onDismiss()}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>
            <fbt desc="Title of the dialog asking a freshly signed-in guest to join the group as a full member">
              Join <fbt:param name="groupName">{groupName}</fbt:param>?
            </fbt>
          </DialogTitle>
          <DialogDescription>
            <fbt desc="Body of the join-group dialog explaining what becoming a member unlocks">
              Join as a full member so your friends can see what you're interested in and going to.
            </fbt>
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={onDismiss}>
            {fbt('Not now', 'Button to dismiss the join-group dialog without joining')}
          </Button>
          <Button onClick={onJoin}>
            <fbt desc="Button to confirm joining the group as a full member from the post-signin dialog">Join group</fbt>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
